import React from 'react';
import { Icons2 } from './Icons2';
import './PlatformCapabilities.css';

const features = [
  {
    icon: Icons2.PersonalisedLearningPaths,
    name: 'Personalised Learning Paths',
    quote:
      'Every learner gets a path built around their role and skill gaps not a generic course catalogue.',
  },
  {
    icon: Icons2.MyTeamDashboard,
    name: 'My Team Dashboard',
    quote:
      'Managers assign courses, track completion, and see team progress without asking HR for a report.',
  },
  {
    icon: Icons2.SkillsCompetencyTracking,
    name: 'Skills & Competency Tracking',
    quote:
      'Map skills to roles, identify gaps, and watch proficiency grow across your entire organisation.',
  },
  {
    icon: Icons2.RealTimeAnalytics,
    name: 'Real-Time Analytics',
    quote:
      'Track learning hours, completion rates, and on-the-job impact with reports you can share straight with leadership.',
  },
  {
    icon: Icons2.HrmsIntegration,
    name: 'HRMS Integration',
    quote:
      'Sync with your existing HR system - Magnetix integrates with leading HRMS platforms so your learning and HR data stay connected.',
  },
  {
    icon: Icons2.GamificationMotivation,
    name: 'Gamification & Motivation',
    quote:
      'Badges, leaderboards, and points that make people want to come back not dread logging in.',
  },
];

export default function PlatformCapabilities() {
  return (
    <section className="platform-capabilities">
      <div className="platform-capabilities__container">
        <div className="platform-capabilities__eyebrow">Platform features</div>
        <h2 className="platform-capabilities__heading">
          Everything your learning, onboarding, and upskilling team needs in one
          place.
        </h2>

        <div className="platform-capabilities__grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="platform-capabilities__card">
                <div className="platform-capabilities__chip">
                  <Icon className="platform-capabilities__chip-icon" />
                </div>
                <div className="platform-capabilities__name">
                  {feature.name}
                </div>
                <div className="platform-capabilities__quote">
                  {feature.quote}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
